import SubscriptionReturn from './SubscriptionReturn-view';

export default SubscriptionReturn;
